import React, { useState } from 'react';
import { User, Edit2 } from 'lucide-react';
import { useAuthStore } from '../../../stores/auth-store';
import { EditProfileModal } from './EditProfileModal';

export const ProfileInfoCard: React.FC = () => {
  const { currentUser } = useAuthStore();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const userInitials = currentUser
    ? `${currentUser.firstname?.[0] || ''}${currentUser.lastname?.[0] || ''}`.toUpperCase()
    : 'U';

  return (
    <>
      <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200 tw-p-6">
        <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
          <div className="tw-flex tw-items-center tw-gap-2">
            <User className="tw-w-5 tw-h-5 tw-text-affinicar-primary" />
            <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900">
              Informations personnelles
            </h2>
          </div>
          <button
            onClick={() => setIsEditModalOpen(true)}
            className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-affinicar-primary hover:tw-bg-affinicar-lighter tw-rounded-md tw-transition-colors"
          >
            <Edit2 className="tw-w-4 tw-h-4" />
            Modifier
          </button>
        </div>

        <div className="tw-flex tw-items-start tw-gap-6">
          {/* Avatar */}
          <div className="tw-w-20 tw-h-20 tw-bg-gradient-to-br tw-from-affinicar-primary tw-to-affinicar-secondary tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-white tw-text-2xl tw-font-semibold tw-flex-shrink-0">
            {userInitials}
          </div>

          {/* Infos */}
          <div className="tw-flex-1 tw-space-y-4">
            {/* Ligne 1: Nom complet (gauche) + Poste (droite) */}
            <div className="tw-grid tw-grid-cols-2 tw-gap-4">
              <div>
                <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
                  Nom complet
                </label>
                <p className="tw-text-sm tw-font-medium tw-text-gray-900">
                  {currentUser?.civility ? `${currentUser.civility} ` : ''}
                  {currentUser?.firstname || ''} {currentUser?.lastname || ''}
                </p>
              </div>

              {currentUser?.position && (
                <div>
                  <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
                    Poste
                  </label>
                  <p className="tw-text-sm tw-text-gray-900">
                    {currentUser.position}
                  </p>
                </div>
              )}
            </div>

            {/* Ligne 2: Email (gauche) + Téléphone (droite) */}
            <div className="tw-grid tw-grid-cols-2 tw-gap-4">
              <div>
                <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
                  Email
                </label>
                <p className="tw-text-sm tw-text-gray-900">
                  {currentUser?.email || 'Non renseigné'}
                </p>
              </div>

              <div>
                <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
                  Téléphone
                </label>
                <p className="tw-text-sm tw-text-gray-900">
                  {currentUser?.phone || 'Non renseigné'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EditProfileModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
      />
    </>
  );
};
